import { util } from '@/api/util';
import { contactSearchDbName, contactDbName, personalMarkTable } from './util/const';
import { writeContactsToLoki, writeOrgsToLoki, writeOrgContactsToLoki } from './contact_sync_enterprise_loki';
export const writePersonalMarksToLoki = async (lokiApi, marks, _dbAccount) => {
    if (!marks.length) {
        return;
    }
    const marksWithId = marks.map(item => (Object.assign(Object.assign({}, item), { id: util.getUnique(item.value) })));
    await lokiApi.putAll({
        dbName: contactSearchDbName,
        tableName: personalMarkTable,
        _dbAccount,
    }, marksWithId);
};
export const deletePersonalMarksFromLoki = async (lokiApi, values, _dbAccount) => {
    if (!values.length) {
        return;
    }
    await lokiApi.deleteByByRangeCondition({
        dbName: contactSearchDbName,
        tableName: personalMarkTable,
        adCondition: {
            type: 'anyOf',
            field: 'value',
            args: [values],
        },
        _dbAccount,
    });
};
export const rebuildPersonalContactsFromDexie = async (params) => {
    const { lokiApi, dbApi, contactUtil, _dbAccount } = params;
    const contacts = (await dbApi.getByEqCondition({
        dbName: contactDbName,
        tableName: contactUtil.contactTable,
        query: { type: 'personal' },
    }, _dbAccount));
    if (!contacts || !contacts.length) {
        return;
    }
    const contactIds = contacts.map(c => c.id);
    const contactItems = (await dbApi.getByRangeCondition({
        dbName: contactDbName,
        tableName: contactUtil.contactItemTable,
        adCondition: {
            type: 'anyOf',
            field: 'contactId',
            args: [contactIds],
        },
    }, _dbAccount));
    const orgs = (await dbApi.getByEqCondition({
        dbName: contactDbName,
        tableName: contactUtil.orgTable,
        query: { type: 2001 },
    }, _dbAccount));
    const orgContacts = (await dbApi.getByEqCondition({
        dbName: contactDbName,
        tableName: contactUtil.orgContactTable,
        query: { type: 'personal' },
    }, _dbAccount));
    const allMarks = (await dbApi.getByEqCondition({
        dbName: contactDbName,
        tableName: contactUtil.personalMarkTable,
    }, _dbAccount));
    await Promise.all([
        writeContactsToLoki(lokiApi, contacts, contactItems, _dbAccount),
        writeOrgsToLoki(lokiApi, orgs, _dbAccount),
        writeOrgContactsToLoki(lokiApi, orgContacts, _dbAccount),
        writePersonalMarksToLoki(lokiApi, allMarks, _dbAccount),
    ]);
};
